<template>
  <v-container
    fluid
    fill-height
    class="grey lighten-4"
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex>
        <div class="text-xs-center">
          <v-progress-circular
            :size="50"
            :width="5"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
        <div class="text-xs-center mt-3">
          <span>{{ message }}</span>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["message"]
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/FullpageLoader.vue